import { toggleMenu } from "./header";
import { getSamePageAnchor, scrollToHash } from "./smooth-scrolling";
import "../css/main.css";
import { initializeBlocks } from "./blocks";

document.addEventListener("DOMContentLoaded", () => {
  /**
   * Toggle del header
   */
  toggleMenu();

  initializeBlocks(document);

  /**
   * Smooth scrolling support
   */
  // If a link's href is within the current page, scroll to it instead
  for (const a of document.querySelectorAll("a[href]")) {
    a.addEventListener("click", (e) => {
      scrollToHash(getSamePageAnchor(a), e);
    });
  }
  // Scroll to the element in the URL's hash on load
  scrollToHash(window.location.hash);

  /**
   * ACF7 event listener
   */
  document.addEventListener(
    "wpcf7mailsent",
    (event) => {
      window.gtag("event", "Formulario", {
        event_category: event.detail.contactFormId,
        event_label: event.detail.unitTag,
      });
    },
    false
  );
});
